'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = logger;

var _chalk = require('chalk');

var _store = require('redux-connect/lib/store');

function logger() {
  return function (store) {
    return function (next) {
      return function (action) {
        if (!__DEVELOPMENT__) return next(action);

        if (action.type === _store.END_GLOBAL_LOAD) {
          console.log((0, _chalk.green)('Rendering with store data:'));
          console.log(store.getState());
        }

        return next(action);
      };
    };
  };
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/store/middleware/logger.js
// module id = 2364
// module chunks = 0